export default function SectionHeader({ label, title, sub }) {
  return (
    <div className="mb-10">
      <span className="section-label"> {label}</span>
      <h2 className="section-title">{title}</h2>
      <div className="section-line" />
      {sub && <p className="text-center text-slate-500 text-sm mt-2 tracking-wide">{sub}</p>}
    </div>
  );
}
